<template>
    <img class="w-36 my-2" src="/img/logo.png" alt="Logo do projeto">
</template>

<script>
export default {
    name: 'Logo'
}
</script>

<style scoped>

</style>